import moment from 'moment'
import { Expose, Transform, Type } from 'class-transformer'
import { Truck } from 'react-feather'

import { Appointment } from './Appointment'
import { Base } from './Base'
import { Carrier } from './Carrier'
import { Client } from './Client'
import { Facility } from './Facility'
import { Place } from './Place'

enum TruckloadStatus {
  empty = 'Empty',
  loaded = 'Loaded',
  shipped = 'Shipped',
  canceled = 'Canceled',
}

export class Truckload extends Base {
  static type = 'truckload'
  static typeDisplay = 'Truckload'
  static icon = Truck

  static Status = TruckloadStatus

  type = Truckload.type
  typeDisplay = Truckload.typeDisplay
  icon = Truckload.icon

  @Expose({ name: 'xid' })
  guid: string = ''

  name: string = ''

  @Expose({ name: 'tracking_number' })
  trackingNumber?: string

  @Expose({ name: 'bill_of_lading_number' })
  billOfLadingNumber?: string

  @Expose({ name: 'trailer_number' })
  trailerNumber?: string

  @Type(() => Client)
  client?: Client

  @Type(() => Facility)
  facility?: Facility

  @Type(() => Place)
  place?: Place

  @Type(() => Carrier)
  carrier?: Carrier

  @Type(() => Appointment)
  appointment?: Appointment

  @Expose({ name: 'num_orders' })
  numOrders: number = 0

  status?: string

  @Expose({ name: 'loaded_on' })
  @Transform((value) => (value ? moment(value) : value))
  loadedOn?: moment.Moment

  @Expose({ name: 'shipped_on' })
  @Transform((value) => (value ? moment(value) : value))
  shippedOn?: moment.Moment

  get objPath() {
    const items = []
    if (this.place) {
      items.push(...this.place.objPath)
    }
    items.push(this)
    return items
  }
}

export class TruckloadSMProduct {
  @Expose({ name: 'xid' })
  guid?: string

  name?: string
}

export class TruckloadSMSku {
  @Expose({ name: 'xid' })
  guid?: string

  sku?: string

  @Type(() => TruckloadSMProduct)
  product?: TruckloadSMProduct
}

export class TruckloadSMOrder {
  @Expose({ name: 'xid' })
  guid?: string

  number?: number
  custom1?: string
  custom2?: string
  custom3?: string
}

export class TruckloadSMInventory {
  @Expose({ name: 'xid' })
  guid?: string

  @Type(() => TruckloadSMSku)
  sku?: TruckloadSMSku

  @Expose({ name: 'num_units' })
  numUnits?: number

  @Expose({ name: 'total_units' })
  totalUnits?: number

  @Expose({ name: 'num_ordered' })
  numOrdered?: number
}

export class TruckloadSMContainer {
  @Expose({ name: 'xid' })
  guid?: string

  name?: string

  @Type(() => TruckloadSMInventory)
  inventory?: TruckloadSMInventory[]

  ordered?: boolean
}

export class TruckloadSMShipment {
  @Expose({ name: 'xid' })
  guid: string = ''

  @Expose({ name: 'tracking_number' })
  trackingNumber?: string

  @Expose({ name: 'num_containers' })
  numContainers?: number

  @Expose({ name: 'total_units' })
  totalUnits?: number

  @Type(() => TruckloadSMOrder)
  order?: TruckloadSMOrder

  @Type(() => TruckloadSMContainer)
  containers?: TruckloadSMContainer[]

  @Type(() => TruckloadSMInventory)
  inventory?: TruckloadSMInventory[]
}

export class TruckloadSM {
  @Expose({ name: 'xid' })
  guid?: string

  @Type(() => Client)
  client?: Client

  @Type(() => Facility)
  facility?: Facility

  @Type(() => Carrier)
  carrier?: Carrier

  @Expose({ name: 'tracking_number' })
  trackingNumber?: string

  @Expose({ name: 'bill_of_lading_number' })
  billOfLadingNumber?: string

  @Expose({ name: 'trailer_number' })
  trailerNumber?: string

  @Type(() => TruckloadSMShipment)
  shipments?: TruckloadSMShipment[]
}
